/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type HpRespLocationsModule_viewer$ref = any;
type HpRespPersonalizedCategories_personalization$ref = any;
type HpRespRecentlyViewedItems_itemEdges$ref = any;
type HpRespRecentlyViewedItems_user$ref = any;
export type HpRespLayoutRefetchQueryVariables = {
    readonly hasRecentlyViewedItems: boolean;
    readonly hasUserId: boolean;
    readonly userId: string;
    readonly homepageId: string;
    readonly recentlyViewedItemIds?: ReadonlyArray<string | null> | null;
    readonly isClient: boolean;
};
export type HpRespLayoutRefetchQueryResponse = {
    readonly viewer: {
        readonly homepage: {
            readonly personalization?: {
                readonly " $fragmentRefs": HpRespPersonalizedCategories_personalization$ref;
            } | null;
        } | null;
        readonly user?: {
            readonly " $fragmentRefs": HpRespRecentlyViewedItems_user$ref;
        } | null;
        readonly items?: {
            readonly " $fragmentRefs": HpRespRecentlyViewedItems_itemEdges$ref;
        } | null;
        readonly " $fragmentRefs": HpRespLocationsModule_viewer$ref;
    } | null;
};
export type HpRespLayoutRefetchQuery = {
    readonly response: HpRespLayoutRefetchQueryResponse;
    readonly variables: HpRespLayoutRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "hasRecentlyViewedItems",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hasUserId",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "homepageId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "recentlyViewedItemIds",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isClient",
            "type": "Boolean!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "rootId",
            "variableName": "homepageId"
        } as any)
    ], v2 = ({
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
    } as any), v3 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 3
        } as any),
        ({
            "kind": "Literal",
            "name": "numItems",
            "value": 3
        } as any),
        (v2 /*: any*/)
    ], v4 = [
        (v2 /*: any*/)
    ], v5 = [
        ({
            "kind": "Variable",
            "name": "itemIds",
            "variableName": "recentlyViewedItemIds"
        } as any)
    ], v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "contemporaryTrackingString",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "seller",
        "storageKey": null,
        "args": null,
        "concreteType": "Seller",
        "plural": false,
        "selections": [
            (v6 /*: any*/),
            (v8 /*: any*/)
        ]
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "pricing",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemPricing",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "retailPrice",
                "storageKey": null,
                "args": null,
                "concreteType": "FinancialAmount",
                "plural": false,
                "selections": [
                    (v10 /*: any*/)
                ]
            }
        ]
    } as any), v12 = [
        ({
            "kind": "Literal",
            "name": "limit",
            "value": 1
        } as any)
    ], v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "masterOrZoomPath",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "localizedPdpUrl",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isCustomizable",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isMultiSku",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "vertical",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "displayPrice",
        "storageKey": "displayPrice(isTrade:false,page:\"searchAndBrowse\")",
        "args": [
            {
                "kind": "Literal",
                "name": "isTrade",
                "value": false
            },
            {
                "kind": "Literal",
                "name": "page",
                "value": "searchAndBrowse"
            }
        ],
        "concreteType": "ItemDisplayPriceType",
        "plural": true,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "convertedAmountList",
                "storageKey": null,
                "args": null,
                "concreteType": "ConvertedAmountList",
                "plural": true,
                "selections": [
                    (v10 /*: any*/),
                    (v19 /*: any*/)
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "quantityDisplay",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "percentageOff",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "type",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "showPriceLabel",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "showPriceVariability",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v21 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "lowestShipmentQuote",
        "storageKey": null,
        "args": null,
        "concreteType": "ShipmentQuote",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "complimentaryShipping",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "totalAmount",
                "storageKey": null,
                "args": null,
                "concreteType": "FinancialAmount",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "convertedAmountList",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ConvertedAmountList",
                        "plural": true,
                        "selections": [
                            (v19 /*: any*/),
                            (v10 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "serviceMethod",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentServiceMethod",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isWhiteGlove",
                        "args": null,
                        "storageKey": null
                    },
                    (v8 /*: any*/)
                ]
            },
            (v8 /*: any*/)
        ]
    } as any), v22 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "classification",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemClassification",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "creationDate",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "displayName",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "creators",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemCreator",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "attribution",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "creator",
                "storageKey": null,
                "args": null,
                "concreteType": "Creator",
                "plural": false,
                "selections": [
                    (v23 /*: any*/),
                    (v8 /*: any*/)
                ]
            },
            (v8 /*: any*/)
        ]
    } as any), v25 = ({
        "kind": "LinkedField",
        "alias": "productPhotos",
        "name": "photos",
        "storageKey": "photos(limit:1)",
        "args": (v12 /*: any*/),
        "concreteType": "ItemPhoto",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "placeholder",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "smallPath",
                "args": null,
                "storageKey": null
            },
            (v13 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "versions",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemPhotoVersion",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "webPath",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            (v8 /*: any*/)
        ]
    } as any), v26 = [
        ({
            "kind": "Literal",
            "name": "formatType",
            "value": "MOBILE"
        } as any)
    ], v27 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "quickViewDisplay",
        "storageKey": null,
        "args": null,
        "concreteType": "QuickViewDisplayType",
        "plural": false,
        "selections": [
            (v17 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": "mobileTitle",
                "name": "title",
                "args": (v26 /*: any*/),
                "storageKey": "title(formatType:\"MOBILE\")"
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "paragraphs",
                "storageKey": null,
                "args": null,
                "concreteType": "QuickViewParagraph",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "key",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "text",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": "mobileText",
                        "name": "text",
                        "args": (v26 /*: any*/),
                        "storageKey": "text(formatType:\"MOBILE\")"
                    }
                ]
            }
        ]
    } as any), v28 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "browseUrl",
        "args": null,
        "storageKey": null
    } as any), v29 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "categoryCode",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "HpRespLayoutRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "homepage",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "Homepage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "hasUserId",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "personalization",
                                            "storageKey": null,
                                            "args": (v3 /*: any*/),
                                            "concreteType": "PersonalizationModuleConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "HpRespPersonalizedCategories_personalization",
                                                    "args": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "HpRespLocationsModule_viewer",
                            "args": null
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasUserId",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": (v4 /*: any*/),
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "HpRespRecentlyViewedItems_user",
                                            "args": null
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasRecentlyViewedItems",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "items",
                                    "storageKey": null,
                                    "args": (v5 /*: any*/),
                                    "concreteType": "ItemsConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "HpRespRecentlyViewedItems_itemEdges",
                                            "args": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "HpRespLayoutRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "homepage",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "Homepage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "hasUserId",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "personalization",
                                            "storageKey": null,
                                            "args": (v3 /*: any*/),
                                            "concreteType": "PersonalizationModuleConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PersonalizationModuleEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "PersonalizationModule",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "url",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "categoryTitle",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "variant",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "categoryMainItem",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Item",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v6 /*: any*/),
                                                                        (v7 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        (v11 /*: any*/),
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "photos",
                                                                            "storageKey": "photos(limit:1)",
                                                                            "args": (v12 /*: any*/),
                                                                            "concreteType": "ItemPhoto",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v13 /*: any*/),
                                                                                (v8 /*: any*/)
                                                                            ]
                                                                        },
                                                                        (v8 /*: any*/)
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "categoryItems",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Item",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v14 /*: any*/),
                                                                        (v6 /*: any*/),
                                                                        (v7 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        (v11 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v20 /*: any*/),
                                                                        (v21 /*: any*/),
                                                                        (v22 /*: any*/),
                                                                        (v24 /*: any*/),
                                                                        (v25 /*: any*/),
                                                                        (v27 /*: any*/),
                                                                        (v8 /*: any*/)
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        (v8 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "isClient",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "regionalInfo",
                                    "storageKey": "regionalInfo(regionTypes:\"ITEM_LOCATION\")",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "regionTypes",
                                            "value": "ITEM_LOCATION"
                                        }
                                    ],
                                    "concreteType": "RegionalInfo",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "regionsByZipCode",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "RegionsByZipCode",
                                            "plural": true,
                                            "selections": [
                                                (v23 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "urlLabel",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "weight",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "locationPageExists",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        (v8 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasUserId",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": (v4 /*: any*/),
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "recentHistoryList",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "RecentHistoryItem",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "eventDate",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "item",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Item",
                                                    "plural": false,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "firstPhotoWebPath",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "size",
                                                                    "value": "small"
                                                                }
                                                            ],
                                                            "storageKey": "firstPhotoWebPath(size:\"small\")"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "pdpURL",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v17 /*: any*/),
                                                        (v28 /*: any*/),
                                                        (v29 /*: any*/),
                                                        (v6 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "categoryPath",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v9 /*: any*/),
                                                        (v8 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        (v8 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasRecentlyViewedItems",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "items",
                                    "storageKey": null,
                                    "args": (v5 /*: any*/),
                                    "concreteType": "ItemsConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ItemsEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Item",
                                                    "plural": false,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v28 /*: any*/),
                                                        (v29 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v15 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v14 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v21 /*: any*/),
                                                        (v22 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v25 /*: any*/),
                                                        (v27 /*: any*/),
                                                        (v8 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "HpRespLayoutRefetchQuery",
            "id": "app-buyer-misc/234.0.0-2019-09-26T08:41:36.086Z/HpRespLayoutRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '8325fdb1401d2ee3dfd0e370a2e0fdb2';
export default node;
